import { createContext } from "react";

export const BpContext = createContext(null);
export const AppContext = createContext(null);
